// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'flux... Remove this comment to see the full error message
import { handleActions } from 'flux-actions';
import { Map as ImmutableMap } from 'immutable';
import { AccountsActionTypes } from '../actions';
const initialState = ImmutableMap({
  filter: '',
  hubsFailedToLoad: false
});
export const accounts = handleActions({
  [AccountsActionTypes.FILTER_ACCOUNTS](state, action) {
    return state.set('filter', action.payload.filter);
  }
}, initialState);